<script lang="ts">
  import { Tabs } from 'bits-ui';

  import type { TeoHelpSection } from '@/teoCore/TeoHelp';

  import HelpTabContent from './HelpTabContent.svelte';

  let { sections }: { sections: TeoHelpSection[] } = $props();
</script>

<Tabs.Root
  value={sections.find((s) => s.selected)?.id ?? sections.at(0)?.id}
  class="flex h-[384px] flex-row"
  orientation="vertical"
>
  {#if sections.length > 0}
    <Tabs.List
      class="flex w-[212px] flex-col items-stretch justify-start border-r border-c-divider"
    >
      {#each sections as section (section.id)}
        <Tabs.Trigger
          value={section.id}
          class="border-b border-c-divider p-5 text-left hover:bg-sec-H data-[state=active]:font-semibold data-[state=active]:text-c-link"
          >{section.title}</Tabs.Trigger
        >
      {/each}
    </Tabs.List>
    {#each sections as section (section.id)}
      <HelpTabContent {section} />
    {/each}
  {/if}
</Tabs.Root>
